export const OfficeEmailFollowupState = {
	url: '/email-followups',
	title: 'Office Email Follow-Up',
	template: '<email-followup-page></email-followup-page>',
	lazyLoad: $transition$ => {
		const $ocLazyLoad = $transition$.injector().get('$ocLazyLoad');
		const $log = $transition$.injector().get('$log');
		return import(
			/* webpackChunkName: "officeSettingsEmailFollowUpPageMod" */
			'@Containers/office-email-followup-page/office-email-followup-page.cmp.js'
		)
			.then(res => $ocLazyLoad.load({name: res.default}))
			.catch(err => $log.error(err));
	},
};
